import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import RecipeGallery from './RecipeGallery';

const RecipeDescription = () => {
  const { state: recipe } = useLocation();
  const navigate = useNavigate();

  if (!recipe) {
    return (
      <div style={{ padding: "2rem", textAlign: "center" }}>
        <p>Recipe not found.</p>
        <button onClick={() => navigate(-1)} style={{ marginTop: "1rem" }}>Go Back</button>
      </div>
    );
  }

  const {
    title,
    description,
    image,
    category,
    prepTime,
    cookTime,
    servings,
    difficulty,
    ingredients,
    instructions,
    galleryImages
  } = recipe;

  return (
    <div className="recipe-detail">
      <div className="recipe-banner">
        <img src={image} alt={title} />
      </div>

      <div className="recipe-info">
        <h1>{title}</h1>

   
        <button className="back-btn" onClick={() => navigate(-1)}>← Back to home</button>
      </div>

      <style jsx>{`
        .recipe-detail {
          max-width: 800px;
          margin: 0 auto;
          padding: 2rem 1rem;
        }

        .recipe-banner {
          position: relative;
          border-radius: 12px;
          overflow: hidden;
          margin-bottom: 2rem;
        }

        .recipe-banner img {
          width: 100%;
          height: 300px;
          object-fit: cover;
        }

        .category-badge {
          position: absolute;
          top: 15px;
          left: 15px;
          background: var(--primary-color);
          color: #fff;
          padding: 5px 12px;
          border-radius: 20px;
          font-size: 0.85rem;
          text-transform: capitalize;
        }

        .recipe-info h1 {
          font-size: 2rem;
          margin-bottom: 0.5rem;
        }

        .description {
          color: var(--gray);
          margin-bottom: 1rem;
          font-size: 1rem;
        }

        .meta {
          display: flex;
          flex-wrap: wrap;
          gap: 1rem;
          font-size: 0.95rem;
          margin-bottom: 2rem;
        }

        h2 {
          margin-top: 2rem;
          font-size: 1.4rem;
        }

        .ingredients, .instructions {
          margin-top: 1rem;
          padding-left: 1rem;
          line-height: 1.6;
          color: #333;
        }

        .instructions li {
          margin-bottom: 0.8rem;
        }

        .back-btn {
          margin-top: 2rem;
          background: none;
          border: none;
          color: var(--primary-color);
          font-weight: 500;
          cursor: pointer;
          padding: 0;
        }

        .back-btn:hover {
          text-decoration: underline;
        }
      `}</style>
      <RecipeGallery galleryImages={galleryImages}/>
    </div>
  );
};

export default RecipeDescription;
